import * as React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import "./all.sass";
import useSiteMetadata from "./SiteMetadata";
import { withPrefix } from "gatsby";
import ScrollToTop from "react-scroll-to-top";

const TemplateWrapper = ({ children }) => {
  const { title, description } = useSiteMetadata();
  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix("/")}img/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-32x32.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-16x16.png`}
          sizes="16x16"
        />

        <link
          rel="shortcut icon"
          type="image/x-icon"
          href={`${withPrefix("/")}img/favicon.ico`}
        />

        <meta name="theme-color" content="#fff" />

        <meta name="og_type" property="og:type" content="business.business" />
        <meta name="og_title" property="og:title" content={title} />
        <meta name="og_url" property="og:url" content={`${withPrefix("/")}`} />
        <meta
          property="og:image"
          content={`${withPrefix("/")}img/og-image.png`}
        />
        <meta
          name="google-site-verification"
          content="eDkA-Xekngv9AARgSO7FYovu8ZAjv7qDDkgSwr84zMU"
        />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, minimum-scale=1"
        ></meta>
        <script defer async src="https://cdn.trustindex.io/loader.js"></script>
        <style>
          @import
          url('https://fonts.googleapis.com/css2?family=Permanent+Marker&family=Poppins:wght@100;300;400;600;900&display=swap');
        </style>
      </Helmet>
      <Navbar />
      <div>
        <ScrollToTop smooth color="#555" />
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default TemplateWrapper;
